import axios from "axios";

async function resetPassword(validationCode: string, password: string): Promise<any> {
    const response = await axios.patch(`${process.env.REACT_APP_USER_SESSION_API}/usuarios-ies/atualizar-senha`, {
        codValidacao: validationCode,
        novaSenha: password
    });
    return response.data;
}

export default resetPassword;